import { lang } from '@/utils/filters'
// console(lang('请输入'))
import { bus } from '@utils/common'

const RULESJson = function() {
  return {
    required: { message: lang('请输入'), required: true, trigger: ['blur', 'change'] },
    requiredPostalCod: { message: lang('请先输入邮编'), required: true, trigger: ['blur', 'change'] },
    requiredTrim: { required: true, pattern: '[^ \x22]+', message: lang('请输入'), trigger: ['blur', 'change'] },
    requiredSelect: { message: lang('请选择'), required: true, trigger: ['blur', 'change'] },
    lengthTwo: { min: 0, max: 2, message: lang('限2个字符内'), trigger: ['blur'] },
    fourty: { max: 40, message: lang('限40个字符内'), trigger: ['blur', 'change'] },
    senderName: { validator: senderName, min: 1, max: 60, trigger: ['blur', 'change'] }, // 寄件人姓名
    senderMobilePhone: { min: 0, max: 11, validator: checkPhone, trigger: ['blur', 'change'] }, // 寄件人手机号
    receiverName: { min: 2, max: 11, message: lang('姓名不正确'), trigger: ['blur', 'change'] },
    receiverMobilePhone: { min: 0, max: 11, validator: checkPhone, trigger: ['blur', 'change'] }, // 收件人手机号
    // goods: { message: '请输入物品类型', trigger: ['blur', 'change'] }, // 物品类型名称
    goodsName: { message: lang('请输入物品名称'), trigger: ['blur', 'change'] }, // 物品名称
    packageTotalWeight: { validator: integerWeight, trigger: ['blur', 'change'] }, // 物品重量
    packageNumber: { validator: integerNum, trigger: ['blur', 'change'] }, // 物品件数
    // payment: { message: '请输入支付方式名称', trigger: ['blur', 'change'] }, // 支付方式名称
    declaredValue: { validator: integerNum, trigger: ['blur', 'change'] }, // 物品价值
    checkPassword: { validator: checkPassword, trigger: ['blur', 'change'] }, // 验证密码
    tenNumStrChar: { validator: tenNumStr, trigger: ['blur', 'change'] }, // 验证密码
    checkPhone: { validator: checkPhone, trigger: ['blur', 'change'] },
    phoneAndMobile: { validator: phoneAndMobile, trigger: ['blur', 'change'] },
    canNotHasChinase: { validator: canNotHasChinase, trigger: ['blur', 'change'] },
    senderCompany: { validator: senderCompany, trigger: ['blur', 'change'] },
    postalCode: { validator: postalCode, trigger: ['blur', 'change'] },
    email: { validator: email, trigger: ['blur', 'change'] },
    stopSellTime: { validator: stopSellTime, trigger: ['blur'] }, // 数字999
    account: { message: lang('账号不能为空'), required: true, trigger: ['blur', 'change'] },
  }
}
export const RULES = RULESJson()
bus.$on('langJsonChange', (data) => {
  const RULESJsonData = RULESJson()
  Object.keys(RULESJsonData).forEach(element => {
    RULES[element] = Object.assign({}, RULESJsonData[element])
  })
})
export const VALIDATION = {
  'num_chinese_en': {
    'value': /^([\u4e00-\u9fa5A-Za-z0-9]{1,12})$/i,
    'label': lang('中文字符/数字/英文，长度为1-12位'),
  },
  'canNotHasChinase': {
    'value': /[\u4E00-\u9FA5]/i,
    'label': lang('不能输入中文'),
  },
  // 'phoneNumber': {
  //   'value': /^1[3|4|5|7|8][0-9]\d{8,8}$/,
  //   'label': '输入的手机号码格式不正确',
  // },
  'phoneNumber': {
    // 'value': /^1\d{10}$/,
    'value': /\d$/, // 国际版去掉限制
    'label': lang('输入的手机号码格式不正确'),
  },
  'phoneAndMobile': {
    'value': /^\d{10}$/,
    'label': lang('请输入10位数字'),
  },
  'address': {
    'value': /.*/i,
    'label': lang('输入的地址格式不正确'),
  },
  'float': {
    'value': /(^[1-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/i,
    'label': lang('请输入大于0且保留两位小数点的数字'),
  },
  'integerNum': {
    'value': /^([1-9][0-9]*)$/i,
    'label': lang('请输入大于0的整数'),
  },
  'checkPassword': {
    'value': /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[_\W])[a-zA-Z0-9_\W]{8,}$/,
    'label': lang('长度8位及以上，包含大、小写字母，数字，特殊字符'),
  },
  // 'ten_num_str': {
  //   'value': /^([@,\.#%'\+\*\-:;^_`()&$/A-Za-z0-9]{1,12})$/i,
  //   'label': '仅支持10个以内的字母、数字、部分符号',
  // },
  'ten_num_str': {
    'value': /^([A-Za-z0-9]{1,10})$/i,
    'label': lang('仅支持10个以内的字母、数字'),
  },
  'checkBlack': {
    'value': /\s+/,
    'label': '请输入',
  },
  'senderName': {
    'value': /^[a-z_A-Z0-9-\.!@#\$%\\\^&\*\)\(\+=\{\}\[\]\/",'<>~\·`\?:;|äöüÄÖÜñáéíóúü\s]+$/i,
    'label': lang('仅支持字母、数字、符号'),
  },
  'senderCompany': {
    'value': /^[a-z_A-Z0-9-\.!@#\$%\\\^&\*\)\(\+=\{\}\[\]\/",'<>~\·`\?:;|äöüÄÖÜñáéíóúü\s]+$/i,
    'label': lang('仅支持字母、数字、符号、空格'),
  },
  'postalCode': {
    'value': /^[0-9]*$/,
    'label': lang('仅支持数字'),
  },
  'email': {
    'value': /^[A-Za-z0-9äöüÄÖÜñáéíóúü]+([-_\.][A-Za-z0-9äöüÄÖÜñáéíóúü]*)*@([A-Za-z0-9äöüÄÖÜñáéíóúü\-]+\.)+[A-Za-zäöüÄÖÜñáéíóúü]{2,6}$/i,
    'label': lang('输入的电子邮箱格式不正确'),
  },
  stopSellTime: {
    value: /^[1-9][0-9]{0,2}$/,
    label: lang('数字:1-999'),
  },
}

// @desc 权限名称30个中文字符/数字/英文
export function num_chinese_en(rule, value, callback) {
  if (value && !VALIDATION.num_chinese_en.value.test(value)) {
    callback(new Error(lang(VALIDATION.num_chinese_en.label)))
  } else {
    callback()
  }
}
// 校验手机号不能超过11位，且为数字 TODO
export function checkPhone(rule, value, callback) {
  if (value && !VALIDATION.phoneNumber.value.test(value)) {
    callback(new Error(lang(VALIDATION.phoneNumber.label)))
  } else {
    callback()
  }
}

// 手机号和座机号
export function phoneAndMobile(rule, value, callback) {
  if (value && !VALIDATION.phoneAndMobile.value.test(value)) {
    callback(new Error(lang(VALIDATION.phoneAndMobile.label)))
  } else {
    if (VALIDATION.checkBlack.value.test(value)) {
      callback(new Error(lang('请勿输入空格')))
    } else {
      callback()
    }
  }
}
// 校验输入的地址格式是否正确
export function checkAddressFormat(rule, value, callback) {
  if (value.length < 1 || value.length > 256) {
    callback(new Error(lang('详细地址只能在1-256字符之间')))
  } else {
    if (value && !VALIDATION.address.value.test(value)) {
      callback(new Error(lang(VALIDATION.address.label)))
    } else if (VALIDATION.checkBlack.value.test(value)) {
      callback(new Error(lang('请勿输入空格')))
    } else {
      callback()
    }
  }
}
//  小数
export function integerWeight(rule, value, callback) {
  if (!value && !VALIDATION.float.value.test(value)) {
    callback(new Error(lang(VALIDATION.float.label)))
  } else {
    callback()
  }
}
//  纯数字
export function integerNum(rule, value, callback) {
  if (value && !VALIDATION.integerNum.value.test(value)) {
    callback(new Error(lang(VALIDATION.integerNum.label)))
  } else {
    callback()
  }
}

// 验证密码
export function checkPassword(rule, value, callback) {
  if (value && !(VALIDATION.checkPassword.value.test(value) && (/\d/).test(value))) {
    callback(new Error(lang(VALIDATION.checkPassword.label)))
  } else {
    callback()
  }
}

// 物品名称
export function checkGoodsName(rule, value, callback) {
  if (value.length > 20) {
    callback(new Error(lang('物品名称长度不能大于20个字符')))
  } else {
    callback()
  }
}

export function tenNumStr(rule, value, callback) {
  if (value && !VALIDATION.ten_num_str.value.test(value)) {
    callback(new Error(lang(VALIDATION.ten_num_str.label)))
  } else {
    callback()
  }
}

// 是否为{}空对象
export function isNullObj(rule, value, callback) {
  if (JSON.stringify(value) === '{}') {
    callback(new Error(lang('请选择')))
  } else {
    callback()
  }
}

// 是否为空格
export function isNull(rule, value, callback) {
  if (VALIDATION.checkBlack.value.test(value)) {
    callback(new Error(lang('请勿输入空格')))
  } else {
    callback()
  }
}

// 不能有中文
export function canNotHasChinase(rule, value, callback) {
  if (VALIDATION.canNotHasChinase.value.test(value)) {
    callback(new Error(lang('不能输入中文')))
  } else {
    callback()
  }
}

export function senderName(rule, value, callback) {
  if (value && !VALIDATION.senderName.value.test(value)) {
    callback(new Error(lang(VALIDATION.senderName.label)))
  } else {
    callback()
  }
}

export function senderCompany(rule, value, callback) {
  if (value && !VALIDATION.senderCompany.value.test(value)) {
    callback(new Error(lang(VALIDATION.senderCompany.label)))
  } else {
    callback()
  }
}

export function postalCode(rule, value, callback) {
  if (value && !VALIDATION.postalCode.value.test(value)) {
    callback(new Error(lang(VALIDATION.postalCode.label)))
  } else {
    callback()
  }
}

export function email(rule, value, callback) {
  if (value && !VALIDATION.email.value.test(value)) {
    callback(new Error(lang(VALIDATION.email.label)))
  } else {
    callback()
  }
}

// 999以内数字
export function stopSellTime(rule, value, callback) {
  if (!VALIDATION.stopSellTime.value.test(value) && value) {
    callback(new Error(VALIDATION.stopSellTime.label))
  } else {
    callback()
  }
}
